
import React from 'react'
import img2075 from '../components/images/admeesho.png'
import img2076 from '../components/images/admessho1.png'
const events = () => {
    return (

        <>
            <div className='container'>
                <div className="row  m-2">
                    <img src={img2075} alt='meesho' />
                </div>
                <div className='container text-center'>
                    <h2>Introduction To Meesho Ads</h2>
                    <p>
                        Drive sales and enhance brand visibility with targeted advertising on Meesho, a leading online platform connecting sellers with millions of potential customers. Utilize advanced targeting capabilities to reach your ideal audience effectively, optimize campaigns for maximum ROI, and leverage Meesho Ads’ powerful analytics for strategic insights and continuous improvement in your marketing efforts. Stay ahead in the competitive e-commerce landscape by harnessing Meesho Ads to amplify your brand’s reach and impact.
                    </p>
                </div>
                <img src={img2076} alt='Queryimg' />
                <div className='row'>
                    <div className='col'>
                        <ol>
                            <li><b>Boost Visibility</b> <br />Advertising on Meesho boosts the rank of your catalogs, leading to higher visibility, more clicks, and increased orders. This helps in driving customer engagement and building brand awareness, ensuring effective reach to potential buyers for better sales conversion.
                            </li>
                        </ol>
                    </div>
                    <div className='col'>
                        <ol>
                            <li><b>Increase Your Sales</b> <br />Advertising on Meesho boosts the rank of your catalogs, leading to higher visibility, more clicks, and increased orders. Being present at the right place at the right time enhances your product reach, helping you attract the right customers and ultimately increase your sales.
                            </li>
                        </ol>
                    </div>
                </div >

                <div className='row'>
                    <div className='col'>
                        <ol>
                            <li><b>Attract More Customers</b> <br />Interested customers can conveniently view and shop from your product catalogs when they are prominently featured in the top slots on Meesho's platform, ensuring maximum visibility, accessibility, and engagement with your offerings.
                            </li>
                        </ol>
                    </div>
                    <div className='col'>
                        <ol>
                            <li><b>Track & Manage Ads</b> <br />Interested customers can conveniently view and shop from your product catalogs when prominently featured in Meesho's top slots, ensuring maximum visibility and engagement. This strategic placement drives increased sales and brand recognition.
                            </li>
                        </ol>
                    </div>
                </div >
                <div className='row'>
                    <div className='col'>
                        <ol>
                            <li><b>Pay only for Click</b> <br />Interested customers can conveniently view and shop from your product catalogs featured prominently in Meesho's top slots, ensuring maximum visibility and engagement. This strategic placement drives increased sales and brand recognition, with payment required only upon customer clicks.
                            </li>
                        </ol>
                    </div>
                    <div className='col'>
                        <ol>
                            <li><b>Control Costs</b> <br />You create the campaigns, meticulously analyze performance data, and decide when to run or pause them based on insightful performance metrics and trends, ensuring strategic campaign management for maximum effectiveness.
                            </li>
                        </ol>
                    </div>
                </div >
            </div>

        </>
    )
}

export default events